import * as types from './hourlyVolumeShareActionType';

// Rad Hourly Volume Share Actions - start
export const fetchRadHourlyVolumeShareUnReadDetailsRequest = (payload) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST,
    payload: payload
});
export const fetchRadHourlyVolumeShareUnReadDetailsSuccess = (data) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS,
    payload: data
});
export const fetchRadHourlyVolumeShareUnReadDetailsFailure = (error) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE,
    payload: error
});

export const fetchRadHourlyVolumeShareReadDetailsRequest = (payload) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST,
    payload: payload
});
export const fetchRadHourlyVolumeShareReadDetailsSuccess = (data) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS,
    payload: data
});
export const fetchRadHourlyVolumeShareReadDetailsFailure = (error) => ({
    type: types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE,
    payload: error
});

export const exportRadHourlyVolumeShareRequest = (data) => ({
    type: types.EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST,
    payload: data
});
export const exportRadHourlyVolumeShareSuccess = (data) => ({
    type: types.EXPORT_RAD_HOURLY_VOLUME_SHARE_SUCCESS,
    payload: data
});
export const exportRadHourlyVolumeShareFailure = (error) => ({
    type: types.EXPORT_RAD_HOURLY_VOLUME_SHARE_FAILURE,
    payload: error
});

export const getDropdownRadSitesRequest = () => ({
    type: types.GET_DORPDOWN_RAD_SITES_REQUEST
});
export const getDropdownRadSitesSuccess = (data) => ({
    type: types.GET_DORPDOWN_RAD_SITES_SUCCESS,
    payload: data
});
export const getDropdownRadSitesFailure = (error) => ({
    type: types.GET_DORPDOWN_RAD_SITES_FAILURE,
    payload: error
});

export const getWorklistByRpceIdRequest = (rpceId) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_REQUEST,
    payload: rpceId
});
export const getWorklistByRpceIdSuccess = (data) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_SUCCESS,
    payload: data
});
export const getWorklistByRpceIdFailure = (error) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_FAILURE,
    payload: error
});

export const getPraticesByWorklistIdRequest = (worklistId) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_REQUEST,
    payload: worklistId
});
export const getPraticesByWorklistIdSuccess = (data) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_SUCCESS,
    payload: data
});
export const getPraticesByWorklistIdFailure = (error) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_FAILURE,
    payload: error
});

export const getSubPraticesByPraticeIdRequest = (praticeId) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST,
    payload: praticeId
});
export const getSubPraticesByPraticeIdSuccess = (data) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS,
    payload: data
});
export const getSubPraticesByPraticeIdFailure = (error) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE,
    payload: error
});

export const getSiteBySubPraticeIdRequest = (subPraticeId) => ({
    type: types.GET_SITE_BY_SUB_PRATICE_ID_REQUEST,
    payload: subPraticeId
});
export const getSiteBySubPraticeIdSuccess = (data) => ({
    type: types.GET_SITE_BY_SUB_PRATICE_ID_SUCCESS,
    payload: data
});
export const getSiteBySubPraticeIdFailure = (error) => ({
    type: types.GET_SITE_BY_SUB_PRATICE_ID_FAILURE,
    payload: error
});
// Rad Hourly Volume Share Actions - end